import { environment } from "../config/environment";

// Define apiBaseUrl once for all API calls
export const apiBaseUrl = environment.apiBaseUrl;

// Constants for error messages
export const WAMO_MESSAGE =
  "I didn't quite get that. Please see your options and try again.";
export const ERROR_MESSAGE =
  "An error occurred. Please refresh the page and try again.";

// Helper function to get current datetime in PST format
export const getCurrentPSTDateTime = (): string => {
  const now = new Date();
  const pstDateTime = new Date(
    now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
  );
  return (
    pstDateTime.getFullYear() +
    "-" +
    String(pstDateTime.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(pstDateTime.getDate()).padStart(2, "0") +
    " " +
    String(pstDateTime.getHours()).padStart(2, "0") +
    ":" +
    String(pstDateTime.getMinutes()).padStart(2, "0") +
    ":" +
    String(pstDateTime.getSeconds()).padStart(2, "0")
  );
};

// Session management
let currentSessionId: string | null = null;

export const initializeSession = (): string => {
  if (!currentSessionId) {
    currentSessionId = crypto.randomUUID();
  }
  return currentSessionId;
};

export const getCurrentSessionId = (): string => {
  if (!currentSessionId) {
    return initializeSession();
  }
  return currentSessionId;
};

export const resetSession = (): void => {
  currentSessionId = null;
};
